export { TabComponent } from './tab.component';
export { TabSetComponent } from './tab-set.component';
export { L_TabModule } from './tab.module';



// WEBPACK FOOTER //
// ./.tmp/tab/index.ts